var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor-container"},[_c('vue-editor',{attrs:{"editor-toolbar":_vm.customToolbar},on:{"input":_vm.updateContent},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }